<template>
  <div id="app">
    <div class="container">
      <Header></Header>
      <router-view></router-view>
      <Footer class="hidden-xs"></Footer>
    </div>
  </div>
</template>

<script>
import Header from '@/base/header'
import Footer from '@/base/footer'

 export default {
   data () {
     return {

     }
   },
   components: {
    Header,
    Footer
   }
 }
</script>

<style lang="stylus"  rel="stylesheet/stylus">
.btn-circle 
  z-index: 9999
  position: fixed
  right:20%
  width: 50px
  height: 50px
  line-height: 50px!important
  border-radius: 25px!important
  padding: 0!important
  box-shadow:inset 0 0 10px rgba(0,0,0, .2)
  &.top 
    bottom: 25%
  &.download
    bottom: 16%
 





.box
  display: flex
  flex-direction: column
  .box-row
    display: flex 
    flex-direction: row
    .content
      margin: 20px
      flex: 1
      overflow: hidden
.box-row
  display: flex 
  flex-direction: row
  .content
    margin: 20px
    flex: 1
    overflow: hidden
</style>


// WEBPACK FOOTER //
// src/App.vue